import { api, AxiosRequestConfigWithMetadata } from '../../services/api.service'

export interface CampaignEntity {
  id: number
  name: string
  name_de: string
  url: string
  icon: string
  position: number
  show_new_banner: boolean
}

class CampaignApi {
  async getCampaigns(): Promise<CampaignEntity[]> {
    const apiCall = await api.get<CampaignEntity[]>('/api/campaign', {
      functionName: 'campaign_getCampaigns'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }
}

export const campaignApi = new CampaignApi()
